module.exports = __webpack_public_path__ + "img/DCIImg10.f669a4d2.png";